// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__sJMw6"};